import { useEffect } from 'react';

var useDocumentTitle = function useDocumentTitle(title) {
  useEffect(function () {
    document.title = title;
  }, [title]);
};

export default useDocumentTitle;